import { AutofocusDirective } from '../../../../shared/directive/autofocus.directive';
import { ConfirmationDialogComponent } from './../../../../shared/component/confirmation-dialog/confirmation-dialog.component';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  signal,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ReactiveFormsModule, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogModule,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { forms } from './form-definitions';
import { DynamicFormComponent } from '@anihis/shared';
import { DentalRecordComponent } from './forms/dental-record/dental-record.component';
import { ClinicObservationDogRabiesComponent } from './forms/clinic-observation-dog-rabies/clinic-observation-dog-rabies.component';
import { ClinicalExaminationReportComponent } from './forms/clinical-examination-report/clinical-examination-report.component';
import { ClinicalExaminationCertificateComponent } from './forms/clinical-examination-certificate/clinical-examination-certificate.component';
import { DischargeEpicrisisComponent } from './forms/discharge-epicrisis/discharge-epicrisis.component';
import { PotvrdaSterilizacijeComponent } from './forms/potvrda-sterilizacije/potvrda-sterilizacije.component';
import { CertificateOriginHealthComponent } from './forms/certificate-origin-health/certificate-origin-health.component';
import { RabiesExaminationCertificateComponent } from './forms/rabies-examination-certificate/rabies-examination-certificate.component';
import { PotvrdaBlankoComponent } from './forms/potvrda-blanko/potvrda-blanko.component';
import { RabiesVaccinationCertificateComponent } from './forms/rabies-vaccination-certificate/rabies-vaccination-certificate.component';
import { BandagesMaintenanceComponent } from './forms/bandages-maintenance/bandages-maintenance.component';
import { DurogesicPatchInstructionsComponent } from './forms/durogesic-patch-instructions/durogesic-patch-instructions.component';
import { ReferralForHistopathologyComponent } from './forms/referral-for-histopathology/referral-for-histopathology.component';
import { InstructionForExaminationComponent } from './forms/instruction-for-examination/instruction-for-examination.component';
import { CardioPulmonaryDirofilariasisComponent } from './forms/cardio-pulmonary-dirofilariasis/cardio-pulmonary-dirofilariasis.component';
import { ChemotherapyProtocolComponent } from './forms/chemotherapy-protocol/chemotherapy-protocol.component';
import { ProcedureUnderGeneralAnesthesiaComponent } from './forms/procedure-under-general-anesthesia/procedure-under-general-anesthesia.component';
import { VetlabAnamnestickiComponent } from './forms/vetlab-anamnesticki/vetlab-anamnesticki.component';
import { PotvrdeAntibiogramComponent } from './forms/potvrde-antibiogram/potvrde-antibiogram.component';
import { LabBiohemijaDogComponent } from './forms/lab-biohemija-dog/lab-biohemija-dog.component';
import { ResultTrioDogComponent } from './forms/result-trio-dog/result-trio-dog.component';
import { ResultTrioCatComponent } from './forms/result-trio-cat/result-trio-cat.component';
import { UltrasoundFindingComponent } from './forms/ultrasound-finding/ultrasound-finding.component';
import { UrineFindingComponent } from './forms/urine-finding/urine-finding.component';
import { SpermogramFindingComponent } from './forms/spermogram-finding/spermogram-finding.component';
import { RtgFindingComponent } from './forms/rtg-finding/rtg-finding.component';
import { RadiologyFindingComponent } from './forms/radiology-finding/radiology-finding.component';
import { CpvCcvFindingComponent } from './forms/cpv-ccv-finding/cpv-ccv-finding.component';
import { OrthopedicFindingComponent } from './forms/orthopedic-finding/orthopedic-finding.component';
import { OphthalmologyReportComponent } from './forms/ophthalmology-report/ophthalmology-report.component';
import { MriFindingComponent } from './forms/mri-finding/mri-finding.component';
import { LeishmaniaFindingComponent } from './forms/leishmania-finding/leishmania-finding.component';
import { KoproloskiFindingComponent } from './forms/koproloski-finding/koproloski-finding.component';
import { CdvFindingComponent } from './forms/cdv-finding/cdv-finding.component';
import { BaepFindingComponent } from './forms/baep-finding/baep-finding.component';
import { BabesiaFindingComponent } from './forms/babesia-finding/babesia-finding.component';
import { AnalysisPointsFindingComponent } from './forms/analysis-points/analysis-points.component';
import { Nalaz4dLComponent } from './forms/nalaz-4d-l/nalaz-4d-l.component';
import { OwnerStatementVaccinationComponent } from './forms/owner-statement-vaccination/owner-statement-vaccination.component';
import { OwnerStatementNewPassportComponent } from './forms/owner-statement-new-passport/owner-statement-new-passport.component';
import { OwnerStatementDeregistrationComponent } from './forms/owner-statement-deregistration/owner-statement-deregistration.component';
import { OwnerStatementDebtInstallmentsComponent } from './forms/owner-statement-debt-installments/owner-statement-debt-installments.component';
import { OwnerStatementDentalTreatmentComponent } from './forms/owner-statement-dental-treatment/owner-statement-dental-treatment.component';
import { OwnerStatementInpatientAdmissionComponent } from './forms/owner-statement-inpatient-admission/owner-statement-inpatient-admission.component';
import { PrijemniFormularComponent } from './forms/prijemni-formular/prijemni-formular.component';
import { OwnerStatementOwnershipChangeComponent } from './forms/owner-statement-ownership-change/owner-statement-ownership-change.component';
import { OwnerStatementTreatmentProcedureComponent } from './forms/owner-statement-treatment-procedure/owner-statement-treatment-procedure.component';
import { OwnerStatementEuthanasiaComponent } from './forms/owner-statement-euthanasia/owner-statement-euthanasia.component';
import { LabBiohemijaCatComponent } from './forms/lab-biohemija-cat/lab-biohemija-cat.component';
import { LabHematoBioCatComponent } from './forms/lab-hemato-bio-cat/lab-hemato-bio-cat.component';
import { LabHematoDogComponent } from './forms/lab-hemato-dog/lab-hemato-dog.component';
import { LabHematoBioDogComponent } from './forms/lab-hemato-bio-dog/lab-hemato-bio-dog.component';
import { LabHematoCatComponent } from './forms/lab-hemato-cat/lab-hemato-cat.component';
import { FnaFindingComponent } from './forms/fna-finding/fna-finding.component';
import { FipTestComponent } from './forms/fip-test/fip-test.component';
import { FivTestComponent } from './forms/fiv-test/fiv-test.component';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';
import { blurAllMaskedDateInputs } from '@anihis/shared/src/functions/date-input-mask';
import {
  ReportType,
  SerialNumberConfirmationsService,
} from '@anihis/core/data-access';
import { FormStore } from './form.store';
import { LoadingStatus } from '../../../../shared/enums/loading';
import { AnimalsService } from '@anihis/core/data-access';
import { forkJoin, of, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

interface FormDefinition {
  id?: string;
  name: string;
  category?: string;
  inputs?: Array<{
    formControlName: string;
    require?: boolean;
    type?: 'input' | 'textbox' | 'date' | 'checkbox' | 'select';
  }>;
  groups?: Array<{
    groupName: string;
    inputs: Array<{
      formControlName: string;
      require?: boolean;
      type?: 'input' | 'textbox' | 'date' | 'checkbox' | 'select';
    }>;
  }>;
  type: ReportType;
}

interface FormGroupDictionary {
  [key: string]: any;
}

@Component({
  selector: 'anihis-add-form-dialog',
  templateUrl: './add-form-dialog.component.html',
  styleUrls: ['./add-form-dialog.component.scss'],
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDialogActions,
    TranslocoModule,
    InstructionForExaminationComponent,
    DentalRecordComponent,
    ClinicObservationDogRabiesComponent,
    ProcedureUnderGeneralAnesthesiaComponent,
    ClinicalExaminationReportComponent,
    ClinicalExaminationCertificateComponent,
    DischargeEpicrisisComponent,
    PotvrdaSterilizacijeComponent,
    CertificateOriginHealthComponent,
    RabiesExaminationCertificateComponent,
    PotvrdaBlankoComponent,
    BandagesMaintenanceComponent,
    DurogesicPatchInstructionsComponent,
    ReferralForHistopathologyComponent,
    CardioPulmonaryDirofilariasisComponent,
    ChemotherapyProtocolComponent,
    VetlabAnamnestickiComponent,
    PotvrdeAntibiogramComponent,
    LabBiohemijaDogComponent,
    OphthalmologyReportComponent,
    LabBiohemijaCatComponent,
    LabHematoCatComponent,
    LabHematoBioCatComponent,
    LabHematoDogComponent,
    LabHematoBioDogComponent,
    FnaFindingComponent,
    FipTestComponent,
    FivTestComponent,
    DynamicFormComponent,
    ResultTrioDogComponent,
    ResultTrioCatComponent,
    UltrasoundFindingComponent,
    UrineFindingComponent,
    CpvCcvFindingComponent,
    SpermogramFindingComponent,
    RtgFindingComponent,
    RadiologyFindingComponent,
    OrthopedicFindingComponent,
    MriFindingComponent,
    LeishmaniaFindingComponent,
    KoproloskiFindingComponent,
    CdvFindingComponent,
    BaepFindingComponent,
    BabesiaFindingComponent,
    AnalysisPointsFindingComponent,
    Nalaz4dLComponent,
    OwnerStatementVaccinationComponent,
    OwnerStatementNewPassportComponent,
    OwnerStatementDeregistrationComponent,
    OwnerStatementDebtInstallmentsComponent,
    OwnerStatementDentalTreatmentComponent,
    OwnerStatementInpatientAdmissionComponent,
    PrijemniFormularComponent,
    OwnerStatementOwnershipChangeComponent,
    OwnerStatementTreatmentProcedureComponent,
    OwnerStatementEuthanasiaComponent,
    RabiesVaccinationCertificateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [FormStore],
})
export class AddFormDialogComponent
  extends FormBaseComponent
  implements OnInit, AfterViewInit
{
  @ViewChild(DentalRecordComponent)
  dentalRecordComponent!: DentalRecordComponent;

  @ViewChild(ClinicalExaminationReportComponent)
  clinicalExaminationReportComponent!: ClinicalExaminationReportComponent;

  @ViewChild(ClinicalExaminationCertificateComponent)
  clinicalExaminationCertificateComponent!: ClinicalExaminationCertificateComponent;

  @ViewChild(DischargeEpicrisisComponent)
  dischargeEpicrisisComponent!: DischargeEpicrisisComponent;

  @ViewChild(PotvrdaSterilizacijeComponent)
  potvrdaSterilizacijeComponent!: PotvrdaSterilizacijeComponent;

  @ViewChild(CertificateOriginHealthComponent)
  certificateOriginHealthComponent!: CertificateOriginHealthComponent;

  @ViewChild(RabiesExaminationCertificateComponent)
  rabiesExaminationCertificateComponent!: RabiesExaminationCertificateComponent;

  @ViewChild(PotvrdaBlankoComponent)
  potvrdaBlankoComponent!: PotvrdaBlankoComponent;

  @ViewChild(RabiesVaccinationCertificateComponent)
  rabiesVaccinationCertificateComponent!: RabiesVaccinationCertificateComponent;

  @ViewChild(DurogesicPatchInstructionsComponent)
  durogesicPatchInstructionsComponent!: DurogesicPatchInstructionsComponent;

  @ViewChild(BandagesMaintenanceComponent)
  bandagesMaintenanceComponent!: BandagesMaintenanceComponent;

  @ViewChild(CardioPulmonaryDirofilariasisComponent)
  cardioPulmonaryDirofilariasisComponent!: CardioPulmonaryDirofilariasisComponent;

  @ViewChild(ChemotherapyProtocolComponent)
  chemotherapyProtocolComponent!: ChemotherapyProtocolComponent;

  @ViewChild(OwnerStatementVaccinationComponent)
  ownerStatementVaccinationComponent!: OwnerStatementVaccinationComponent;

  @ViewChild(OwnerStatementNewPassportComponent)
  ownerStatementNewPassportComponent!: OwnerStatementNewPassportComponent;

  @ViewChild(OwnerStatementDeregistrationComponent)
  ownerStatementDeregistrationComponent!: OwnerStatementDeregistrationComponent;

  @ViewChild(OwnerStatementDebtInstallmentsComponent)
  ownerStatementDebtInstallmentsComponent!: OwnerStatementDebtInstallmentsComponent;

  @ViewChild(OwnerStatementTreatmentProcedureComponent)
  ownerStatementTreatmentProcedureComponent!: OwnerStatementTreatmentProcedureComponent;

  @ViewChild(OwnerStatementDentalTreatmentComponent)
  ownerStatementDentalTreatmentComponent!: OwnerStatementDentalTreatmentComponent;

  @ViewChild(OwnerStatementInpatientAdmissionComponent)
  ownerStatementInpatientAdmissionComponent!: OwnerStatementInpatientAdmissionComponent;

  @ViewChild(PrijemniFormularComponent)
  prijemniFormularComponent!: PrijemniFormularComponent;

  @ViewChild(OwnerStatementOwnershipChangeComponent)
  ownerStatementOwnershipChangeComponent!: OwnerStatementOwnershipChangeComponent;

  @ViewChild(OwnerStatementEuthanasiaComponent)
  ownerStatementEuthanasiaComponent!: OwnerStatementEuthanasiaComponent;

  @ViewChild(ProcedureUnderGeneralAnesthesiaComponent)
  procedureUnderGeneralAnesthesiaComponent!: ProcedureUnderGeneralAnesthesiaComponent;

  @ViewChild(ResultTrioDogComponent)
  resultTrioDogComponent!: ResultTrioDogComponent;

  @ViewChild(ResultTrioCatComponent)
  resultTrioCatComponent!: ResultTrioCatComponent;

  @ViewChild(CpvCcvFindingComponent)
  cpvCcvFindingComponent!: CpvCcvFindingComponent;

  @ViewChild(UltrasoundFindingComponent)
  ultrasoundFindingComponent!: UltrasoundFindingComponent;

  @ViewChild(UrineFindingComponent)
  urineFindingComponent!: UrineFindingComponent;

  @ViewChild(SpermogramFindingComponent)
  spermogramFindingComponent!: SpermogramFindingComponent;

  @ViewChild(RtgFindingComponent)
  rtgFindingComponent!: RtgFindingComponent;

  @ViewChild(RadiologyFindingComponent)
  radiologyFindingComponent!: RadiologyFindingComponent;

  @ViewChild(OrthopedicFindingComponent)
  orthopedicFindingComponent!: OrthopedicFindingComponent;

  @ViewChild(MriFindingComponent)
  mriFindingComponent!: MriFindingComponent;

  @ViewChild(LeishmaniaFindingComponent)
  leishmaniaFindingComponent!: LeishmaniaFindingComponent;

  @ViewChild(CdvFindingComponent)
  cdvFindingComponent!: CdvFindingComponent;

  @ViewChild(BaepFindingComponent)
  baepFindingComponent!: BaepFindingComponent;

  @ViewChild(BabesiaFindingComponent)
  babesiaFindingComponent!: BabesiaFindingComponent;

  @ViewChild(AnalysisPointsFindingComponent)
  analysisPointsFindingComponent!: AnalysisPointsFindingComponent;

  @ViewChild(Nalaz4dLComponent)
  nalaz4dLComponent!: Nalaz4dLComponent;

  @ViewChild(KoproloskiFindingComponent)
  koproloskiFindingComponent!: KoproloskiFindingComponent;

  @ViewChild(OphthalmologyReportComponent)
  ophthalmologyReportComponent!: OphthalmologyReportComponent;

  @ViewChild(ClinicObservationDogRabiesComponent)
  clinicObservationDogRabiesComponent!: ClinicObservationDogRabiesComponent;

  @ViewChild(FnaFindingComponent)
  fnaFindingComponent!: FnaFindingComponent;

  @ViewChild(FipTestComponent)
  fipTestComponent!: FipTestComponent;

  @ViewChild(FivTestComponent)
  fivTestComponent!: FivTestComponent;

  @ViewChild(InstructionForExaminationComponent)
  instructionForExaminationComponent!: InstructionForExaminationComponent;

  @ViewChild(ReferralForHistopathologyComponent)
  referralForHistopathologyComponent!: ReferralForHistopathologyComponent;

  @ViewChild(VetlabAnamnestickiComponent)
  vetlabAnamnestickiComponent!: VetlabAnamnestickiComponent;

  store = inject(FormStore);
  serialNumberConfirmationsService = inject(SerialNumberConfirmationsService);
  animalsService = inject(AnimalsService);

  // Transloco service for language-aware UI (used to show Serbian-only external PDF)
  translocoService = inject(TranslocoService);

  dialogRef = inject(MatDialogRef<AddFormDialogComponent>);
  private dialogService = inject(MatDialog);
  override cd = inject(ChangeDetectorRef);
  data = inject(MAT_DIALOG_DATA);

  readonly status = LoadingStatus;
  readonly isSaving = signal(false);

  currentFormIndex = 0;
  currentFormGroup!: FormGroup;
  forms: FormDefinition[] = forms;
  // Centralized asset paths and filenames for downloadable PDFs
  private readonly ASSET_PATH = '/assets/document';
  private readonly ASSETS = {
    VETLAB: 'Zahtev-VetLab.pdf',
    SEQOMICS: 'Zahtev-SeqoMics-genetika.pdf',
    NALAZ_NEURO: 'Nalaz-Neuroloski.pdf',
    ENDOSCOPY_UPPER: 'Endoskopski-pregled-Gornji-digestivni-trakt.pdf',
    NALAZ_ECHO_CAT: 'Nalaz-Echo-srca-macke.pdf',
    NALAZ_ECHO_DOG: 'Nalaz-Echo-srca-psa.pdf',
    NALAZ_EKG: 'Nalaz-EKG.pdf.pdf',
    KARTON_STOM: 'Karton-Stomatoloski.pdf',
    TITER_PASTER: 'Zahtev-Titar-Paster.pdf',
    PROT_24H: 'Prot-24h-protokol.pdf',
    PROT_MULTI: 'Prot-Visednevni.pdf',
    PROT_ANESTH: 'Protokol-Anestezije.pdf',
    PROT_DIRO: 'Protokol-Dirofilarioze.pdf',
    PROT_INF: 'Protokol-infuzuje.pdf',
    PREGLED_OKA: 'Pregled%20oka.pdf',
  } as const;

  // List of form ids that have dedicated standalone components rendered explicitly
  explicitComponentFormIds: string[] = [
    'dental-record',
    'clinical-examination-certificate',
    'discharge-epicrisis',
    'certificate-origin-health',
    'rabies-examination-certificate',
    'bandages-maintenance',
    'durogesic-patch-instructions',
    'potvrda-blanko',
    'potvrda-sterilizacije',
    'anamnesticki-karton',
    'prot-hemoterapije',
    'lab-biohemija-results',
    'result-trio-dog',
    'cpv-ccv-finding',
    'result-trio-cat',
    'ultrasound-finding',
    'urine-finding',
    'spermogram-finding',
    'rtg-finding',
    'radiology-finding',
    'orthopedic-finding',
    'mri-finding',
    'leishmania-finding',
    'koproloski-finding',
    'ophthalmology-report',
    'lab-hemato-bio-cat',
    'lab-hemato-bio-dog',
    'lab-hemato-cat',
    'lab-hemato-dog',
    'lab-biohemija-cat',
    'fna-finding',
    'fip-test-result',
    'fiv-test-result',
    'cdv-finding',
    'baep-finding',
    'babesia-finding',
    'analysis-points',
    'nalaz-4d-l',
    'owner-statement-vaccination',
    'owner-statement-new-passport',
    'owner-statement-deregistration',
    'owner-statement-debt-installments',
    'owner-statement-treatment-procedure',
    'owner-statement-dental-treatment',
    'owner-statement-inpatient-admission',
    //'owner-statement-anesthesia',
    'prijemni-formular',
    'owner-statement-ownership-change',
    'owner-statement-euthanasia',
    'rabies-vaccination-certificate',
  ];
  // Categories shown in the first step (English labels)
  categories = [
    { key: 'ExternalDocuments', label: 'External Documents' },
    { key: 'Laboratories', label: 'Laboratories' },
    { key: 'Certificates', label: 'Certificates' },
    { key: 'Instructions', label: 'Instructions' },
    { key: 'Protocols', label: 'Protocols' },
    { key: 'Findings', label: 'Findings' },
    { key: 'Consent', label: 'Consent' },
  ];
  selectedCategory: string | null = null;
  // Index of the selected form (null until user selects)
  selectedFormIndex: number | null = null;
  // Search query for filtering forms across all categories
  searchQuery = '';

  get searchResults(): FormDefinition[] {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) return [];
    return this.forms.filter((f) => {
      const englishName = f.name.toLowerCase();
      const translatedName = this.translocoService
        .translate(f.name)
        .toLowerCase();
      return englishName.includes(q) || translatedName.includes(q);
    });
  }
  // Human-readable label of selected category (falls back to 'Choose Type')
  get selectedCategoryLabel(): string {
    if (!this.selectedCategory) return 'Choose Type';
    const found = this.categories.find((c) => c.key === this.selectedCategory);
    return found ? found.label : 'Choose Type';
  }

  openPreopInstruction(): void {}

  openPostopInstruction(): void {}

  openCesareanInstruction(): void {}

  openTravelInstruction(): void {}

  openEcollarInstruction(): void {}

  openDogVaccinationProgram(): void {}

  openCatVaccinationProgram(): void {}

  // Human-readable label of selected form for the second step
  get selectedFormLabel(): string {
    if (this.selectedFormIndex === null) return 'Choose Form';
    const f = this.forms[this.selectedFormIndex];
    return f ? f.name : 'Choose Form';
  }
  readonly ReportType = ReportType;
  formType!: ReportType;
  private _lastChildFormValue: any = null;

  /** Recursively converts Date objects to local "YYYY-MM-DD" strings.
   *  Must be done BEFORE JSON.stringify because JS calls Date.toJSON() before
   *  the replacer, so instanceof Date inside a replacer is always false.
   */
  private serializeDates(value: any): any {
    if (value instanceof Date) {
      const y = value.getFullYear();
      const m = String(value.getMonth() + 1).padStart(2, '0');
      const d = String(value.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }
    if (Array.isArray(value)) {
      return value.map((v) => this.serializeDates(v));
    }
    if (value !== null && typeof value === 'object') {
      const result: any = {};
      for (const key of Object.keys(value)) {
        result[key] = this.serializeDates(value[key]);
      }
      return result;
    }
    return value;
  }

  // Labels for Anamnestic Card controls -> translation keys
  anamnesisLabelMap: { [key: string]: string } = {
    mainReason: 'Main reason for visit',
    historyPresentIllness: 'History of present illness',
    vaccines: 'Vaccines',
    antiparasiticEndo_howOften: 'Antiparasitic (endo) - How often',
    antiparasiticEndo_lastTime: 'Antiparasitic (endo) - Last time',
    antiparasiticEndo_product: 'Antiparasitic (endo) - Product',
    antiparasiticEcto_howOften: 'Antiparasitic (ecto) - How often',
    antiparasiticEcto_lastTime: 'Antiparasitic (ecto) - Last time',
    antiparasiticEcto_product: 'Antiparasitic (ecto) - Product',
    pastIllnesses: 'Past illnesses',
    surgicalInterventions: 'Surgical interventions',
    injuries: 'Injuries',
    currentMedications: 'Current medications',
    housing: 'Housing',
    allergies: 'Allergies',
    nutrition: 'Nutrition',
    additionalData: 'Additional anamnestic data',
    // technicianSignature and veterinarianSignature removed per request
    cardNumber: 'Clinical exam - Card number',
    admissionDate: 'Admission date',
    bodyWeightKg: 'Body weight (kg)',
    temperatureC: 'Temperature (°C)',
    dehydrationPercent: 'Dehydration (%)',
    pulse: 'Pulse',
    respiration: 'Respiration (/min)',
    vpk: 'VPK',
    arterijskiPritisak: 'Arterial pressure',
    mucousMembranes: 'Mucous membranes',
    lymphNodes: 'Lymph nodes',
    clinicalChanges: 'Description of clinical changes',
    diffDiagnosis1: 'Differential diagnosis 1',
    diffDiagnosis2: 'Differential diagnosis 2',
    diffDiagnosis3: 'Differential diagnosis 3',
    diffDiagnosis4: 'Differential diagnosis 4',
    diffDiagnosis5: 'Differential diagnosis 5',
    diffDiagnosis6: 'Differential diagnosis 6',
    workList: 'Work list (proposed tests/procedures)',
    comments: 'Comments',
    diagnosis: 'Diagnosis',
    therapy: 'Therapy',
    control: 'Control',
    veterinarianName: 'veterinarianName',
  };

  constructor() {
    super();
    this.currentFormGroup = this.fb.group({});
    this.form = this.currentFormGroup;

    // Zatvaranje dijaloga na klik na pozadinu ili pritisak Escape tastera
    this.dialogRef.backdropClick().subscribe(() => {
      this.confirmClose();
    });

    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.confirmClose();
      }
    });
  }

  override ngOnInit() {
    // Wait for user to pick a category and a form
    // react to language changes so template updates visibility of Serbian-only options
    if (this.translocoService && (this.translocoService as any).langChanges$) {
      (this.translocoService as any).langChanges$.subscribe(() =>
        this.cd.markForCheck(),
      );
    }
  }

  // Returns true when active language is Serbian (matches 'sr' or 'sr-*')
  get isSerbianLang(): boolean {
    const lang =
      (this.translocoService.getActiveLang &&
        this.translocoService.getActiveLang()) ||
      '';
    return typeof lang === 'string' && lang.startsWith('sr');
  }

  // Trigger download of the Serbian VetLab PDF from assets
  downloadZahtevVetLab(): void {
    this.downloadByKey('VETLAB');
  }

  // Trigger download of the SeqoMics genetics request PDF from assets
  downloadZahtevSeqoMics(): void {
    this.downloadByKey('SEQOMICS');
  }

  // Trigger download of the Neurology finding PDF from assets
  downloadNalazNeuroloski(): void {
    this.downloadByKey('NALAZ_NEURO');
  }

  // Trigger download of the Endoscopic finding PDF from assets
  downloadEndoskopski(): void {
    this.downloadByKey('ENDOSCOPY_UPPER');
  }

  // Trigger download of the Echo (cat) finding PDF from assets
  downloadNalazEchoMacke(): void {
    this.downloadByKey('NALAZ_ECHO_CAT');
  }

  // Trigger download of the Echo (dog) finding PDF from assets
  downloadNalazEchoPsa(): void {
    this.downloadByKey('NALAZ_ECHO_DOG');
  }

  // Trigger download of the EKG finding PDF from assets
  downloadNalazEkg(): void {
    this.downloadByKey('NALAZ_EKG');
  }
  // Trigger download of the Dental Record PDF from assets
  downloadDentalRecord(): void {
    this.downloadByKey('KARTON_STOM');
  }

  // Trigger download of the Titar Paster request PDF from assets
  downloadZahtevTitarPaster(): void {
    this.downloadByKey('TITER_PASTER');
  }

  // Trigger download of the 24-hour protocol PDF from assets
  download24hProtocol(): void {
    this.downloadByKey('PROT_24H');
  }

  // Trigger download of the Multi-day protocol PDF from assets
  downloadVisednevniProtocol(): void {
    this.downloadByKey('PROT_MULTI');
  }

  // Trigger download of the Anesthesia protocol PDF from assets
  downloadAnesthesiaProtocol(): void {
    this.downloadByKey('PROT_ANESTH');
  }

  // Trigger download of the Heartworm Treatment protocol PDF from assets
  downloadDirofilariozeProtocol(): void {
    this.downloadByKey('PROT_DIRO');
  }

  // Trigger download of the Infusion protocol PDF from assets
  downloadInfusionProtocol(): void {
    this.downloadByKey('PROT_INF');
  }

  // Centralized helper to download an asset (keeps behaviour identical)
  private downloadAsset(href: string, filename: string): void {
    try {
      const a = document.createElement('a');
      a.href = href;
      a.setAttribute('download', filename);
      a.target = '_blank';
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      window.open(href, '_blank', 'noopener');
    }
  }

  // Helper: download by asset key from the `ASSETS` map
  private downloadByKey(key: keyof typeof this.ASSETS, saveAs?: string): void {
    const filename = this.ASSETS[key];
    const downloadName = saveAs ?? filename;
    this.downloadAsset(`${this.ASSET_PATH}/${filename}`, downloadName);
  }

  // Trigger download of the Ophthalmology (Pregled oka) PDF from assets
  downloadPregledOka(): void {
    this.downloadByKey('PREGLED_OKA', 'Pregled oka.pdf');
  }

  selectCategory(categoryKey: string, stepper?: MatStepper) {
    this.selectedCategory = categoryKey;
    if (stepper) {
      stepper.next();
    }
  }

  // Return forms filtered by selected category using simple heuristics
  get filteredForms(): FormDefinition[] {
    if (!this.selectedCategory) {
      return this.forms;
    }

    // Show only forms that have the same `category` value as selectedCategory
    const res = this.forms.filter(
      (f: any) => f.category === this.selectedCategory,
    );
    return res;
  }

  selectFormByDefinition(def: FormDefinition, stepper?: MatStepper) {
    // Prefer lookup by id (robust when filtered arrays or object copies are used).
    let idx = -1;
    if (def && typeof def.id === 'string') {
      idx = this.forms.findIndex((f) => f.id === def.id);
    }
    // Fallback to reference equality if id-based lookup failed
    if (idx === -1) {
      idx = this.forms.indexOf(def as any);
    }

    if (idx >= 0) {
      this.selectForm(idx, stepper);
    }
  }

  selectFormFromSearch(def: FormDefinition, stepper: MatStepper) {
    // Set category so filteredForms is populated if user goes back
    this.selectedCategory = def.category ?? null;

    let idx = -1;
    if (def && typeof def.id === 'string') {
      idx = this.forms.findIndex((f) => f.id === def.id);
    }
    if (idx === -1) {
      idx = this.forms.indexOf(def as any);
    }
    if (idx >= 0) {
      this.currentFormIndex = idx;
      this.selectedFormIndex = idx;
      const selectedForm = this.forms[idx];
      this.formType = selectedForm.type;
      const group: FormGroupDictionary = {};
      if (selectedForm.groups && selectedForm.groups.length > 0) {
        selectedForm.groups.forEach((gr) => {
          const controls: FormGroupDictionary = {};
          gr.inputs.forEach((input) => {
            controls[input.formControlName] = [
              '',
              input.require ? Validators.required : [],
            ];
          });
          group[gr.groupName] = this.fb.group(controls);
        });
      } else if (selectedForm.inputs) {
        selectedForm.inputs.forEach((input) => {
          group[input.formControlName] = [
            '',
            input.require ? Validators.required : [],
          ];
        });
      }
      this.currentFormGroup = this.fb.group(group);
      this.form = this.currentFormGroup;
      this._lastChildFormValue = null;
      // On a linear stepper we must advance step by step.
      // Go from step 1 → step 2 → step 3.
      stepper.next();
      stepper.next();
    }
  }

  ngAfterViewInit() {
    // Ako je učitana klinicka komponenta, pretplatite se na njeno emitovanje formChange
    if (this.clinicalExaminationReportComponent) {
      this.clinicalExaminationReportComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.clinicalExaminationCertificateComponent) {
      this.clinicalExaminationCertificateComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.dischargeEpicrisisComponent) {
      this.dischargeEpicrisisComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.potvrdaSterilizacijeComponent) {
      this.potvrdaSterilizacijeComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.certificateOriginHealthComponent) {
      this.certificateOriginHealthComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.rabiesExaminationCertificateComponent) {
      this.rabiesExaminationCertificateComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.potvrdaBlankoComponent) {
      this.potvrdaBlankoComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.durogesicPatchInstructionsComponent) {
      this.durogesicPatchInstructionsComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.bandagesMaintenanceComponent) {
      this.bandagesMaintenanceComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.chemotherapyProtocolComponent) {
      this.chemotherapyProtocolComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.cardioPulmonaryDirofilariasisComponent) {
      this.cardioPulmonaryDirofilariasisComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }

    if (this.dentalRecordComponent) {
      this.dentalRecordComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.referralForHistopathologyComponent) {
      this.referralForHistopathologyComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.instructionForExaminationComponent) {
      this.instructionForExaminationComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    if (this.vetlabAnamnestickiComponent) {
      this.vetlabAnamnestickiComponent.formChange.subscribe((value: any) => {
        this.handleFormChange(value);
      });
    }
    if (this.rabiesVaccinationCertificateComponent) {
      this.rabiesVaccinationCertificateComponent.formChange.subscribe(
        (value: any) => {
          this.handleFormChange(value);
        },
      );
    }
    this.cd.markForCheck();
  }

  confirmClose(): void {
    const confirmDialogRef = this.dialogService.open(
      ConfirmationDialogComponent,
      {
        width: '400px',
        data: {
          title: 'Confirm Close',
          text: 'Are you sure you want to close this dialog? All unsaved changes will be lost.',
        },
        disableClose: true,
      },
    );

    confirmDialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmed) {
        this.dialogRef.close();
      }
    });
  }

  selectForm(index: number, stepper?: MatStepper) {
    this.currentFormIndex = index;
    this.selectedFormIndex = index;
    const selectedForm = this.forms[index];

    this.formType = selectedForm.type;
    const group: FormGroupDictionary = {};

    // Build nested FormGroup structure for forms that define groups.
    // This matches the shape emitted by complex child components
    // (e.g. { previousHistory: { previousHistoryNote: '...' } }).
    if (selectedForm.groups && selectedForm.groups.length > 0) {
      selectedForm.groups.forEach((gr) => {
        const controls: FormGroupDictionary = {};
        gr.inputs.forEach((input) => {
          controls[input.formControlName] = [
            '',
            input.require ? Validators.required : [],
          ];
        });
        group[gr.groupName] = this.fb.group(controls);
      });
    } else if (selectedForm.inputs) {
      selectedForm.inputs.forEach((input) => {
        group[input.formControlName] = [
          '',
          input.require ? Validators.required : [],
        ];
      });
    }

    this.currentFormGroup = this.fb.group(group);
    this.form = this.currentFormGroup;
    this._lastChildFormValue = null;
    if (stepper) {
      stepper.next();
    }
  }

  handleFormChange(value: any) {
    if (!value || Object.keys(value).length === 0) return;

    // Always store latest value — used by custom components whose
    // form structure is not reflected in currentFormGroup controls.
    this._lastChildFormValue = value;

    // Try patching nested value directly (works when currentFormGroup
    // has nested FormGroup keys matching the emitted object).
    try {
      this.currentFormGroup.patchValue(value, { emitEvent: false });
      this.cd.markForCheck();
      return;
    } catch (err) {
      // fallback to manual mapping below
    }

    // Fallback: iterate keys and set controls if they exist on the root
    // or inside nested groups. This supports both flat and nested payloads.
    for (const parentKey in value) {
      if (!Object.prototype.hasOwnProperty.call(value, parentKey)) continue;
      const val = value[parentKey];

      // If root control exists, set it
      if (this.currentFormGroup.controls[parentKey]) {
        this.currentFormGroup.controls[parentKey].setValue(val, {
          emitEvent: false,
        });
        continue;
      }

      // If value is object and there's a nested FormGroup with that name, patch it.
      // Avoid `instanceof` (compiler error TS2358) — use duck-typing instead.
      if (typeof val === 'object' && val !== null) {
        const control = this.currentFormGroup.controls[parentKey];
        if (control && typeof (control as any).patchValue === 'function') {
          (control as any).patchValue(val, { emitEvent: false });
          continue;
        }
      }

      // If value is nested but the target controls are at root (flat structure),
      // try to map child keys to root controls.
      if (typeof val === 'object' && val !== null) {
        for (const childKey in val) {
          if (!Object.prototype.hasOwnProperty.call(val, childKey)) continue;
          if (this.currentFormGroup.controls[childKey]) {
            this.currentFormGroup.controls[childKey].setValue(val[childKey], {
              emitEvent: false,
            });
          }
        }
      }
    }

    this.cd.markForCheck();
  }

  clearValue(formControlName: string) {
    if (this.currentFormGroup.controls[formControlName]) {
      this.currentFormGroup.controls[formControlName].setValue('');
    }
  }

  clearForm() {
    this.form.reset();
    if (this.dentalRecordComponent) {
      this.dentalRecordComponent.clearForm();
    }
    // When returning from the Fill Form step, reset selected form so step label shows "Choose Form"
    this.selectedFormIndex = null;
  }

  /** Marks all forms touched, triggers validation UI, returns true if invalid. */
  override checkFormValidity(): boolean {
    const root = this.elementRef?.nativeElement;
    if (root) {
      blurAllMaskedDateInputs(root);
    }

    this.currentFormGroup.markAllAsTouched();

    const childComponents: any[] = [
      this.dentalRecordComponent,
      this.clinicalExaminationReportComponent,
      this.clinicalExaminationCertificateComponent,
      this.dischargeEpicrisisComponent,
      this.potvrdaSterilizacijeComponent,
      this.certificateOriginHealthComponent,
      this.rabiesExaminationCertificateComponent,
      this.potvrdaBlankoComponent,
      this.durogesicPatchInstructionsComponent,
      this.bandagesMaintenanceComponent,
      this.cardioPulmonaryDirofilariasisComponent,
      this.chemotherapyProtocolComponent,
      this.ownerStatementVaccinationComponent,
      this.ownerStatementNewPassportComponent,
      this.ownerStatementDeregistrationComponent,
      this.ownerStatementDebtInstallmentsComponent,
      this.ownerStatementTreatmentProcedureComponent,
      this.ownerStatementDentalTreatmentComponent,
      this.ownerStatementInpatientAdmissionComponent,
      this.prijemniFormularComponent,
      this.ownerStatementOwnershipChangeComponent,
      this.ownerStatementEuthanasiaComponent,
      this.procedureUnderGeneralAnesthesiaComponent,
      this.resultTrioDogComponent,
      this.resultTrioCatComponent,
      this.cpvCcvFindingComponent,
      this.ultrasoundFindingComponent,
      this.urineFindingComponent,
      this.spermogramFindingComponent,
      this.rtgFindingComponent,
      this.radiologyFindingComponent,
      this.orthopedicFindingComponent,
      this.mriFindingComponent,
      this.leishmaniaFindingComponent,
      this.cdvFindingComponent,
      this.baepFindingComponent,
      this.babesiaFindingComponent,
      this.analysisPointsFindingComponent,
      this.nalaz4dLComponent,
      this.koproloskiFindingComponent,
      this.ophthalmologyReportComponent,
      this.clinicObservationDogRabiesComponent,
      this.fnaFindingComponent,
      this.fipTestComponent,
      this.fivTestComponent,
      this.referralForHistopathologyComponent,
      this.instructionForExaminationComponent,
      this.vetlabAnamnestickiComponent,
      this.rabiesVaccinationCertificateComponent,
    ];

    const childFormsValidity: boolean[] = [];
    for (const cmp of childComponents) {
      if (cmp && (cmp as any).form) {
        (cmp as any).form.markAllAsTouched();
        childFormsValidity.push((cmp as any).form.valid);
      }
    }

    const parentValid = this.currentFormGroup.valid;
    const childrenValid =
      childFormsValidity.length === 0
        ? true
        : childFormsValidity.every((v) => v === true);
    this.cd.markForCheck();
    if (!parentValid || !childrenValid) {
      setTimeout(() => this.scrollToFirstError(), 50);
    }
    return !parentValid || !childrenValid;
  }

  saveChanges() {
    if (this.checkFormValidity()) return;
    this.isSaving.set(true);

    // Sync the active child component's current form value into currentFormGroup
    // before reading getRawValue(). This bypasses debounceTime in child components
    // and ensures values typed right before clicking Save are always captured.
    const activeChildComponents: any[] = [
      this.dentalRecordComponent,
      this.clinicalExaminationReportComponent,
      this.clinicalExaminationCertificateComponent,
      this.dischargeEpicrisisComponent,
      this.potvrdaSterilizacijeComponent,
      this.certificateOriginHealthComponent,
      this.rabiesExaminationCertificateComponent,
      this.potvrdaBlankoComponent,
      this.durogesicPatchInstructionsComponent,
      this.bandagesMaintenanceComponent,
      this.cardioPulmonaryDirofilariasisComponent,
      this.chemotherapyProtocolComponent,
      this.ownerStatementVaccinationComponent,
      this.ownerStatementNewPassportComponent,
      this.ownerStatementDeregistrationComponent,
      this.ownerStatementDebtInstallmentsComponent,
      this.ownerStatementTreatmentProcedureComponent,
      this.ownerStatementDentalTreatmentComponent,
      this.ownerStatementInpatientAdmissionComponent,
      this.prijemniFormularComponent,
      this.ownerStatementOwnershipChangeComponent,
      this.ownerStatementEuthanasiaComponent,
      this.procedureUnderGeneralAnesthesiaComponent,
      this.resultTrioDogComponent,
      this.resultTrioCatComponent,
      this.cpvCcvFindingComponent,
      this.ultrasoundFindingComponent,
      this.urineFindingComponent,
      this.spermogramFindingComponent,
      this.rtgFindingComponent,
      this.radiologyFindingComponent,
      this.orthopedicFindingComponent,
      this.mriFindingComponent,
      this.leishmaniaFindingComponent,
      this.cdvFindingComponent,
      this.baepFindingComponent,
      this.babesiaFindingComponent,
      this.analysisPointsFindingComponent,
      this.nalaz4dLComponent,
      this.koproloskiFindingComponent,
      this.ophthalmologyReportComponent,
      this.clinicObservationDogRabiesComponent,
      this.fnaFindingComponent,
      this.fipTestComponent,
      this.fivTestComponent,
      this.referralForHistopathologyComponent,
      this.instructionForExaminationComponent,
      this.vetlabAnamnestickiComponent,
      this.rabiesVaccinationCertificateComponent,
    ];
    let activeChildFormValue: any = null;
    for (const cmp of activeChildComponents) {
      if (cmp && typeof (cmp as any).form?.getRawValue === 'function') {
        activeChildFormValue = (cmp as any).form.getRawValue();
        this.currentFormGroup.patchValue(activeChildFormValue, {
          emitEvent: false,
        });
        break;
      }
    }

    // For custom component forms (no inputs/groups defined), currentFormGroup
    // is empty so getRawValue() returns {}. Use the active child form value instead.
    const hasOwnControls =
      Object.keys(this.currentFormGroup.controls).length > 0;
    const formData = hasOwnControls
      ? this.form.getRawValue()
      : activeChildFormValue ??
        this._lastChildFormValue ??
        this.form.getRawValue();

    // For RabiesVaccinationCertificate, extract and strip the internal serial
    // number UID before storing the JSON — it is operational metadata only.
    let pendingSerialNumberUid: string | null = null;
    let pendingDateIssued: string | null = null;
    let saveableFormData = formData;
    if (this.formType === ReportType.RabiesVaccinationCertificate && formData) {
      const { serialNumberConfirmationUid, ...rest } = formData;
      pendingSerialNumberUid = serialNumberConfirmationUid ?? null;
      const rawDate = formData.dateIssued;
      pendingDateIssued =
        rawDate instanceof Date
          ? rawDate.toISOString()
          : rawDate
            ? new Date(rawDate).toISOString()
            : new Date().toISOString();
      // Keep serialNumberConfirmationUid in saved JSON so backend can resolve
      // the certificate serial number when generating the PDF.
      saveableFormData = {
        ...rest,
        serialNumberConfirmationUid: pendingSerialNumberUid,
      };
    }

    // Pre-process: convert Date objects to local "YYYY-MM-DD" strings before
    // JSON.stringify. A replacer function cannot be used because JS calls
    // Date.prototype.toJSON() before the replacer, so instanceof Date is always
    // false inside a replacer.
    const serialized = this.serializeDates(saveableFormData);
    const jsonString = JSON.stringify(serialized);

    // If rabies form contains new passport/microchip for marking, update the animal first
    let updates$: Observable<any> = of(null);
    if (
      this.formType === ReportType.RabiesVaccinationCertificate &&
      saveableFormData &&
      (saveableFormData.marking === true ||
        saveableFormData.markingSelected === true)
    ) {
      const passportRaw = saveableFormData.passportNumber ?? null;
      const chipRaw = saveableFormData.microchip ?? null;

      const enteredPassport = (passportRaw ?? '').toString().trim();
      const enteredMicrochip = (chipRaw ?? '').toString().trim();

      if (enteredPassport || enteredMicrochip) {
        updates$ = this.animalsService.animalsUidGet(this.data.animalUid).pipe(
          switchMap((res: any) => {
            const animal = res?.animal ?? res;

            const existingMicrochip = (animal.microchip ?? '')
              .toString()
              .trim();
            const existingPassport = (animal.passportNumber ?? '')
              .toString()
              .trim();

            const needsPassportUpdate =
              !!enteredPassport && enteredPassport !== existingPassport;
            const needsMicrochipUpdate =
              !!enteredMicrochip && enteredMicrochip !== existingMicrochip;

            if (!needsPassportUpdate && !needsMicrochipUpdate) {
              return of(null);
            }

            // Determine final values: prefer entered values, fall back to existing
            const finalMicrochip = needsMicrochipUpdate
              ? enteredMicrochip
              : existingMicrochip || undefined;
            const finalPassport = needsPassportUpdate
              ? enteredPassport
              : existingPassport || undefined;

            // Helper: convert null → undefined so FormData doesn't send literal "null"
            const toVal = (v: any) => (v == null ? undefined : v);

            // Set dates as ISO strings: if user entered a new value, stamp with now;
            // otherwise preserve existing date (or undefined if not set)
            const passportDate = needsPassportUpdate
              ? new Date().toISOString()
              : toVal(animal.passportDateTime);
            const markingDate = needsMicrochipUpdate
              ? new Date().toISOString()
              : toVal(animal.markingDateTimeUtc);

            return this.animalsService.animalsUidPutForm(
              this.data.animalUid,
              undefined,
              toVal(animal.profilePicture?.uid),
              animal.visible ?? undefined,
              toVal(animal.owner?.uid),
              toVal(animal.name),
              toVal(animal.breed?.uid),
              animal.gender,
              toVal(animal.birthDateTime),
              toVal(animal.birthDateText),
              animal.color?.length ? animal.color : undefined,
              finalMicrochip,
              finalPassport,
              passportDate,
              toVal(animal.viIssuesAPassport),
              toVal(animal.warning),
              markingDate,
              toVal(animal.pedigree),
              animal.sterilized ?? undefined,
              toVal(animal.sterilizedDateTimeUtc),
              animal.exitusLetalis ?? undefined,
              undefined,
            );
          }),
        );
      }
    }

    updates$.subscribe({
      next: () => {
        this.store
          .saveForm(jsonString, this.data.animalUid, this.formType)
          .subscribe({
            next: (response: any) => {
              if (pendingSerialNumberUid && this.data?.animalUid) {
                this.serialNumberConfirmationsService
                  .serialNumberConfirmationsUidUsePatch(
                    pendingSerialNumberUid,
                    {
                      animalUid: this.data.animalUid,
                      dateIssued: pendingDateIssued
                        ? new Date(pendingDateIssued)
                        : new Date(),
                    },
                  )
                  .subscribe();
              }
              // Refresh animal data so UI shows updated microchip/passport immediately
              if (this.data?.animalUid) {
                this.animalsService
                  .animalsUidGet(this.data.animalUid)
                  .subscribe({
                    next: (res: any) => {
                      const updatedAnimal = res?.animal ?? res;
                      // sanitize nulls so UI doesn't render literal "null" or string 'null'
                      const sanitize = (v: any): any => {
                        if (v === null) return '';
                        if (typeof v === 'string' && v.toLowerCase() === 'null')
                          return '';
                        if (Array.isArray(v)) return v.map((i) => sanitize(i));
                        if (typeof v === 'object' && v !== null) {
                          const out: any = {};
                          for (const key of Object.keys(v)) {
                            out[key] = sanitize(v[key]);
                          }
                          return out;
                        }
                        return v;
                      };
                      let safeAnimal: any;
                      try {
                        safeAnimal = sanitize(updatedAnimal);
                      } catch {
                        safeAnimal = updatedAnimal;
                      }
                      // return updated animal to caller so they can refresh their view
                      this.dialogRef.close({
                        response: 'Save success',
                        updatedAnimal: safeAnimal,
                      });
                    },
                    error: () => {
                      this.dialogRef.close({ response: 'Save success' });
                    },
                  });
              } else {
                this.dialogRef.close({ response: 'Save success' });
              }
            },
            error: (err: any) => {
              console.error('Error saving form:', err);
              this.isSaving.set(false);
            },
          });
      },
      error: (err: any) => {
        console.error('Error updating animal before save:', err);
        this.isSaving.set(false);
      },
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
